import { render, staticRenderFns } from "./deleteRole.vue?vue&type=template&id=3814e765&lang=pug&"
import script from "./deleteRole.vue?vue&type=script&lang=js&"
export * from "./deleteRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports